// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import './index.css';
//import './css/theme.css';
import './css/styles.css';
//import './css/media.css';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

